import { render, staticRenderFns } from "./RiddleAnswerOption.vue?vue&type=template&id=5c7f80f6&scoped=true"
import script from "./RiddleAnswerOption.vue?vue&type=script&lang=ts"
export * from "./RiddleAnswerOption.vue?vue&type=script&lang=ts"
import style0 from "./RiddleAnswerOption.vue?vue&type=style&index=0&id=5c7f80f6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7f80f6",
  null
  
)

export default component.exports